import { render, staticRenderFns } from "./AboutProven.vue?vue&type=template&id=7b6eba12&"
import script from "./AboutProven.vue?vue&type=script&lang=js&"
export * from "./AboutProven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports